// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResourceProgress } from './ResponseResourceProgress';
import {
  ResponseResourceProgressFromJSON,
  ResponseResourceProgressFromJSONTyped,
  ResponseResourceProgressToJSON,
  ResponseResourceProgressToJSONTyped,
} from './ResponseResourceProgress';
import type { ResponseRolloutStatus } from './ResponseRolloutStatus';
import {
  ResponseRolloutStatusFromJSON,
  ResponseRolloutStatusFromJSONTyped,
  ResponseRolloutStatusToJSON,
  ResponseRolloutStatusToJSONTyped,
} from './ResponseRolloutStatus';

/**
 *
 * @export
 * @interface ResponseRolloutSummary
 */
export interface ResponseRolloutSummary {
  /**
   * ClusterRolloutCount is the number of clusters holding the rollout.
   * @type {number}
   * @memberof ResponseRolloutSummary
   */
  clusterRolloutCount?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseRolloutSummary
   */
  identifier?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseRolloutSummary
   */
  operatorName?: string;
  /**
   *
   * @type {Array<ResponseResourceProgress>}
   * @memberof ResponseRolloutSummary
   */
  resourceProgresses?: Array<ResponseResourceProgress>;
  /**
   * Status is derived from the conditions of every cluster copy.
   * @type {ResponseRolloutStatus}
   * @memberof ResponseRolloutSummary
   */
  status?: ResponseRolloutStatus;
}

/**
 * Check if a given object implements the ResponseRolloutSummary interface.
 */
export function instanceOfResponseRolloutSummary(
  value: object,
): value is ResponseRolloutSummary {
  return true;
}

export function ResponseRolloutSummaryFromJSON(
  json: any,
): ResponseRolloutSummary {
  return ResponseRolloutSummaryFromJSONTyped(json, false);
}

export function ResponseRolloutSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseRolloutSummary {
  if (json == null) {
    return json;
  }
  return {
    clusterRolloutCount:
      json['clusterRolloutCount'] == null
        ? undefined
        : json['clusterRolloutCount'],
    identifier: json['identifier'] == null ? undefined : json['identifier'],
    operatorName:
      json['operatorName'] == null ? undefined : json['operatorName'],
    resourceProgresses:
      json['resourceProgresses'] == null
        ? undefined
        : (json['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressFromJSON,
          ),
    status:
      json['status'] == null
        ? undefined
        : ResponseRolloutStatusFromJSON(json['status']),
  };
}

export function ResponseRolloutSummaryToJSON(
  json: any,
): ResponseRolloutSummary {
  return ResponseRolloutSummaryToJSONTyped(json, false);
}

export function ResponseRolloutSummaryToJSONTyped(
  value?: ResponseRolloutSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    clusterRolloutCount: value['clusterRolloutCount'],
    identifier: value['identifier'],
    operatorName: value['operatorName'],
    resourceProgresses:
      value['resourceProgresses'] == null
        ? undefined
        : (value['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressToJSON,
          ),
    status: ResponseRolloutStatusToJSON(value['status']),
  };
}
